// extracted by mini-css-extract-plugin
export var subtitle = "_bk-2";
export var title = "_bk-0";
export var titleNoWrap = "_bk-1";